import { render, staticRenderFns } from "./ClubEdit.vue?vue&type=template&id=cb8af5d2"
import script from "./ClubEdit.vue?vue&type=script&lang=js"
export * from "./ClubEdit.vue?vue&type=script&lang=js"
import style0 from "./ClubEdit.vue?vue&type=style&index=0&id=cb8af5d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports